module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-02-20e4a6ec5e34d6a115ca5ed1d613824e.jpg";